<script>
import {ref} from "vue";

export default {
  name: "InformationPage",
  setup(){

    let page = ref(1)

    return{
      page
    }
  }
}
</script>

<template>

  <div id="main" class="position-relative">
    <img class="bg-login max_width" src="../assets/img/bg-welc.png" alt="" />

    <div class="">

      <div class="div-blur mx-auto p-body">
        <img v-if="page == 1 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/logo_welc.svg" alt="">
        <img v-if="page == 2 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/logo_welc.svg" alt="">
        <img v-if="page == 3 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/contract_icon.svg" alt="">
        <img v-if="page == 4 " class="animate__animated animate__fadeIn  h-50 w-50" src="../assets/img/wallet_icon.svg" alt="">
      </div>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <p v-if="page == 1 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        به خانواده بزرگ دکوبان خوش آمدید
        سوپر اپلیکیشن دکوبان در زمینه فروش کالا
        و ارائه خدمات مشاوره ای و کاریابی در این زمینه ساختمانی است.
        با خدمات ما همراه باشید.
      </p>

      <p v-if="page == 2 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        میتونی در دکوبان فروشنده بشی و کالاهات را به
        جامعه آماری بالای کاربران معرفی کنی
      </p>

      <p v-if="page == 3 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        اگر خدماتی در زمینه ساختمان ارائه میدی
        کافیه پروفایلتو بسازی و فعالیتت را شروع کنی
      </p>

      <p v-if="page == 4 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        اگر نیاز به نیروی کار داری یا جویای کار هستی
        میتونی رایگان آگهیتو بزاری
      </p>

    </div>

    <div dir="rtl" class="w-100 max_width btn-number">
      <router-link v-if="page == 4 " to="/LoginPage" class="text-decoration-none">
        <v-btn class="animate__animated animate__fadeIn w-25 bg-color mr-10 shadow-costom text-white max_width rounded-3 font-4">
          بزن بریم!
        </v-btn>
      </router-link>

      <v-btn v-else @click="page++" class="bg-color w-25 mr-10 shadow-costom text-white max_width rounded-3 font-4">
        برو بعدی
      </v-btn>
    </div>

  </div>

  <div id="web" class="position-relative bg-color-holder">

    <div class="">

      <div class="div-blur mx-auto p-body">
        <img v-if="page == 1 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/logo_welc.svg" alt="">
        <img v-if="page == 2 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/logo_welc.svg" alt="">
        <img v-if="page == 3 " class="animate__animated animate__fadeIn h-50 w-50" src="../assets/img/contract_icon.svg" alt="">
        <img v-if="page == 4 " class="animate__animated animate__fadeIn  h-50 w-50" src="../assets/img/wallet_icon.svg" alt="">
      </div>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <p v-if="page == 1 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        به خانواده بزرگ دکوبان خوش آمدید
        سوپر اپلیکیشن دکوبان در زمینه فروش کالا
        و ارائه خدمات مشاوره ای و کاریابی در این زمینه ساختمانی است.
        با خدمات ما همراه باشید.
      </p>

      <p v-if="page == 2 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        میتونی در دکوبان فروشنده بشی و کالاهات را به
        جامعه آماری بالای کاربران معرفی کنی
      </p>

      <p v-if="page == 3 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        اگر خدماتی در زمینه ساختمان ارائه میدی
        کافیه پروفایلتو بسازی و فعالیتت را شروع کنی
      </p>

      <p v-if="page == 4 " class="animate__animated animate__fadeIn font-4 mt-7 w-100 px-5 text-black text-center">
        اگر نیاز به نیروی کار داری یا جویای کار هستی
        میتونی رایگان آگهیتو بزاری
      </p>

    </div>

    <div class="w-100 max_width btn-number">
      <router-link v-if="page == 4 " to="/LoginPage" class="text-decoration-none">
        <v-btn class="animate__animated animate__fadeIn w-25 bg-white font-color font-bold mr-10 shadow-costom text-white max_width rounded-3 font-4">
          بزن بریم!
        </v-btn>
      </router-link>

      <v-btn v-else @click="page++" class="bg-white font-color w-25 mr-10 font-bold shadow-costom text-white max_width rounded-3 font-4">
        برو بعدی
      </v-btn>
    </div>

  </div>

</template>

<style scoped>
.bg-color-holder{
  background-image: linear-gradient(to top,#FFAF73 , #FF9900);
}
.bg-login {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 103%;
}
.div-blur {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 250px;
  max-width: 470px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
  height: 250px;
  top: 23%;
  left: 50%;
  transform: translate(-50% , 0);
  position: absolute;
  backdrop-filter: saturate(1) blur(15px);
}

.btn-number {
  position: fixed;
  bottom: 30px;
  max-width:500px ;
}

</style>